import { Component, OnInit, ViewChild, AfterViewInit, Inject, Optional } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, MatDialog, MatDialogConfig, MAT_DIALOG_DATA, PageEvent } from '@angular/material'
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { ReportService } from '../services/report.service';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { CustomDateComponent } from './customdate/custom-date.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import * as moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { TransformerManagerService } from '../services/transformerManager.service';
import * as _ from "lodash";
import { count } from 'console';
import { RenewalWindowComponent } from '../renewal-window/renewal-window.component';
import { DashboardService } from '../services/dashboard.service';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr'
import Swal from 'sweetalert2';
//import * as XLSX from 'xlsx';
import * as XLSX from 'xlsx-js-style';

import { debounceTime } from 'rxjs/operators';
import * as FileSaver from 'file-saver';
pdfMake.vfs = pdfFonts.pdfMake.vfs;


@Component({
    selector: 'app-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {
    thresholdInputSubject: Subject<void> = new Subject();
    reportColumns: any;
    commonColumns = ["Transformer Id", "Deviceid", "DATE","Time"]
    // physicalParams: any = ["Transformer Id", "Deviceid", "DATE", "Winding_Temperature", "Ambient_Temperature", "Humidity", "Oil_Temperature", "Oil_Level"];
    physicalParams: any;
    dataSource;
    isUploading = false;
    typeFilter:any;
    data: any;
    filter: any = {};
    TapPositionFilter: any ={};
    transformerIds: any = [];
    paramFilter: string;
    timeFilter: string;
    idFilter: string;
    timeOptions: any = ['Today', 'Yesterday', 'This Week', 'This Month', 'Last Month', 'Custom'];
    parametersOption: any = ['All', 'Physical Parameters', "Electrical Parameters"];
    reportData : any = [];
    transformerParam: string;
    electricalParams = [];
    allParameters = [];
    public counter : any;
    public  TapPositionData : any = [];
    windingtemprature: any[] = [];
    gradient : any;
    kvarating:any;
    isDownloading: boolean = false;
    historyData = [];
     customeSelectedDate:any;
     currentUserData = JSON.parse(localStorage.getItem('userData'));
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    thresholdValues: any;
    deviceID: any;
    totalRecords = 0;
    pageIndex = 0;
    pageSize = 5;
    allDeviceDataForFilter:any;
    lastRecordId: any = 0;
    pageIndexNextCompare: any = 0;
    isPageDownload: boolean=true;
    remainingTime: any = 0;
    filterColumns: any = [];
    downloadMessage = 'Downloading...';
    thresholdInputValue: string = '';
    selectedParameterStatus: any = '';
    parameterList: any[] = [];
    isTapPosition: boolean = false;
    tapCounter: any = 0;
    constructor(private toastr :ToastrService,private reportService: ReportService, private matDialog: MatDialog,
        private ngxLoader: NgxUiLoaderService,@Optional() @Inject(MAT_DIALOG_DATA) public injectedTransformerId: any,private route: ActivatedRoute,private _dashboardService: DashboardService, private transMngSer: TransformerManagerService) { }

    async ngOnInit() {
        if(this.currentUserData.roleid !==1){
            this.getRenewalData();
            }
        if (this.route.snapshot.queryParams['transformerId']) {
            this.transformerParam = this.route.snapshot.queryParams['transformerId'];
            this.ngxLoader.start();
            this.transformerIds = await this.getDdlData();
            this.transformerIds.push("All");
            if(this.transformerIds.length > 0) {
                this.idFilter = this.transformerParam;
                this.timeFilter = 'Today';
                this.filter.transformerId = _.cloneDeep(this.transformerParam).split('[')[0];
                this.filters('date', 'Today');
            } else {
                this.ngxLoader.stop();
            }

        }
        else {
            this.ngxLoader.start();
            this.thresholdInputSubject
                .pipe(debounceTime(2000)) // 1000 ms = 1 second delay
                .subscribe(() => {
                    this.applyParameterAndThresholdFilter();
                });
            this.transformerIds = await this.getDdlData();
            console.log("what Data Is This",this.transformerIds)
            this.transformerIds.push("All");
            if(this.transformerIds.length > 0) {
                if(this.injectedTransformerId != undefined) {
                    this.transformerParam = this.injectedTransformerId;
                } else {
                    this.transformerParam = this.transformerIds[0];
                    this.idFilter = this.transformerParam;
                }
                
                    this.filter.transformerId = _.cloneDeep(this.transformerParam).split('[')[0];        
                    this.getDropdownPeramter(this.filter.transformerId)
               // var todayFilter: any = {};
               // todayFilter = await this.filters('date', 'Today');
               // console.log('TODAY FILTER:', todayFilter);
               // this.filter = {...this.filter, ...todayFilter};
                this.timeFilter = 'Today';
                this.filters('date', 'Today');
            } else {
                this.ngxLoader.stop();
            }

        }



        // this.ngxLoader.start();
        // this.transformerId = await this.getDdlData();
        //console.log('TRANSFORMER ID:',this.transformerId[0]);
        // console.log('API IS CALLED NOW');
        // this.reportService.getReportData(this.filter).toPromise().then(async (response: any) => {
        //     this.reportColumns = this.report1Columns;
        //     this.ngxLoader.stop();
        //     console.log('Response:', response.reportData);
        //     this.dataSource = new MatTableDataSource(response.reportData);
        //     this.data = response.reportData;
        //     this.dataSource.paginator = this.paginator;
        //     this.dataSource.sort = this.sort;
        // })
    }
    applyParameterAndThresholdFilter() {
        // If no selection is made (user wants to reset/clear the filter)
        if (!this.selectedParameterStatus || !this.thresholdInputValue) {
            delete this.filter.parameterName;
            delete this.filter.thresholdValue;
            this.fetchReportData(this.filter);
            return;
        }
    
        this.filter.parameterName = this.selectedParameterStatus.display;
    
        if (this.filter.parameterName === 'Oil_Level') {
            const levelMap: { [key: string]: number } = {
                low: 4,
                medium: 5,
                high: 6
            };
    
            const input = this.thresholdInputValue.toString().toLowerCase();
    
            if (levelMap[input] !== undefined) {
                this.filter.thresholdValue = levelMap[input];
            } else if (['4', '5', '6'].includes(input)) {
                this.filter.thresholdValue = parseInt(input, 10);
            } else {
                this.filter.thresholdValue = 5; // default to medium
            }
        } else {
            this.filter.thresholdValue = this.thresholdInputValue;
        }
    
        this.fetchReportData(this.filter);
    }
    
    
        onThresholdInputChange() {
            this.thresholdInputSubject.next();
        }
    getDdlData() {
        return new Promise((resolve, reject) => {
            this.transMngSer.getTransformerData(JSON.parse(localStorage.getItem('userData')).roleid, JSON.parse(localStorage.getItem('userData')).userid, 'x``z').toPromise().then((response: any) => {
                 if(response.data.length > 0)
                 {
                     this.allDeviceDataForFilter = response.data;
                    resolve(response.data.map(a => a.serialnumber + "[" + a.sitename + "]"));
                 }
                resolve([]);
            });
        })
    }
    getDropdownPeramter(transformerselected: string) {
        const Transformerid = transformerselected.split('[')[0].trim();
        console.log(Transformerid, 'clean transformer id');
    
        this.reportService.getParametersByTransformerId(Transformerid).subscribe(
            (res: any) => {
                const unwanted = [
                  
                    'apPRVStatus',
                    'apOSRStatus',
                    'apBuchholzStatus',
                    'apOTIStatus',
                    'apWTIStatus',
                    'apVunbalance',
                    'apIunbalance',
                    'apCriticalload'
                ];
    
                this.parameterList = res
                    .filter((item: any) => !unwanted.includes(item.parameterName))
                    .map((item: any) => {
                        return {
                            original: item.parameterName,
                            display: this.formatParameterName(item.parameterName),
                            internal: this.getInternalParam(item.parameterName)
                        };
                    });
    
                console.log('Filtered & Formatted Parameters:', this.parameterList);
            },
            (error) => {
                console.error('API Error:', error);
            }
        );
    }
    
    getInternalParam(param: string): string {
        const internalMap: { [key: string]: string } = {
            'apOverload': 'Overload',
            'apUnderload': 'Underload',
            'apHighvolt': 'High Volt',
            'apLowvolt': 'Low Volt',
            'apOiltemperature': 'Oil Temperature',
            'apWindingtemperature': 'Winding Temperature',
            'apVunbalance': 'V Unbalance',
            'apIunbalance': 'I Unbalance',
            'apLowPowerfactor': 'Low Power Factor',
              'apOillevel': 'Oil Level'
        };
    
        return internalMap[param] || param;
    }
    
        formatParameterName(param: string): string {
            const customMap: { [key: string]: string } = {
                'apOverload': 'avgCurrent',
                'apUnderload': 'lowavgCurrent',
                'apHighvolt': 'Average_Voltage',
                'apLowvolt': 'lowAverage_Voltage',
                'apOiltemperature': 'Oil_Temperature',
                'apWindingtemperature': 'Winding_Temperature',
                'apVunbalance': 'vUnbalance',
                'apIunbalance': 'iUnbalance',
                'apLowPowerfactor': 'Avg_Power_Factor',
                'apOillevel': 'Oil_Level'
            };
    
            // If exact match exists in the map, return the mapped value
            if (customMap[param]) {
                return customMap[param];
            }
    
            // Default formatting logic
            if (param.startsWith('ap')) {
                param = param.substring(2);
            }
    
            const result = param.replace(/([A-Z])/g, ' $1');
            return result.charAt(0).toUpperCase() + result.slice(1);
        }
    

    async filters(type: string, param: string) {
        if (type === 'transformerId') {
            this.getDropdownPeramter(param);
             this.selectedParameterStatus = '';
        this.thresholdInputValue = '';
        delete this.filter.parameterName;
        delete this.filter.thresholdValue;
        }
        this.totalRecords = 0;
        this.pageIndex = 0;
        this.pageSize = 5;
        try {
            console.log(type, param);
            // if(this.transformerParam) {
            //     this.filter.transformerId = param;
            // }
            if (type === 'transformerId') {
                this.idFilter = param;
                // this.filter = ;
                //this.filter.transformerId = param
                this.transformerParam = param;
                if(param == "All"){
                    this.filter.transformerId = this.currentUserData.userid;
                } else{
                    this.filter.transformerId = _.cloneDeep(this.transformerParam).split('[')[0];
                }
                this.fetchReportData(this.filter);
            } else if (type === 'date') {
                this.timeFilter = param;
              //  if (Object.keys(this.filter).length > 0) {

                    var filter: any = await this.formatDate(param);
                    //this.filter = this.filter + filter;
                    if (filter.filter === 'This Week' || filter.filter === 'This Month' || filter.filter === 'Last Month') {
                        if (this.filter && this.filter.date) {
                            delete this.filter.date;
                        }
                        this.filter.startDate = filter.startDate;
                        this.filter.endDate = filter.endDate;
                        this.filter.filter = filter.filter;
                    }
                    else if (filter.filter === 'Today' || filter.filter === 'Yesterday') {
                        if (this.filter && this.filter.startDate && this.filter.endDate) {
                            delete this.filter.startDate;
                            delete this.filter.endDate;
                        }
                        this.filter.filter = filter.filter
                        this.filter.date = filter.date;
                        this.fetchReportData(this.filter);
                    }

                    else if (filter.filter === 'Custom') {
                        if (this.filter && this.filter.date) {
                            delete this.filter.date;
                        }
                        if(filter.startDate && filter.endDate) {
                            this.filter.startDate = filter.startDate;
                        this.filter.endDate = filter.endDate;
                        this.filter.filter = filter.filter;
                        }

                    }
                    if(filter.startDate && filter.endDate) {
                    this.fetchReportData(this.filter);
                    }
                    //this.filter = this.filter + '&' + `date=${date}` + '&' + `filter=${param}`;
              //  }


            } else if (type === 'parameters') {
                this.paramFilter = param;
                if (param === 'Physical Parameters') {
                    this.typeFilter = type;
                    this.reportColumns = this.physicalParams;
                    this.filterColumns = this.physicalParams;
                    // this.dataSource = new MatTableDataSource(this.data);;
                    // this.dataSource.paginator = this.paginator;
                    // this.dataSource.sort = this.sort;
                }
                else if (param === 'All') {
                    this.reportColumns = this.allParameters;
                    this.filterColumns = this.allParameters;
                } else if (param === 'Electrical Parameters') {
                    this.reportColumns = this.electricalParams;
                    this.filterColumns = this.electricalParams;
                } else {
                    this.reportColumns = this.allParameters;
                    this.filterColumns = this.reportColumns;
                }
            }


        } catch (error) {
            console.log('ERROR:', error);
        }


    }

    formatDate(param) {
        return new Promise((resolve, reject) => {
            if (param === 'Today') {
                var d = new Date(),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();

                if (month.length < 2)
                    month = '0' + month;
                if (day.length < 2)
                    day = '0' + day;
                resolve({ 'date': [year, month, day].join('-'), 'filter': param })
                // return [year, month, day].join('-');
            } else if (param === 'Yesterday') {     
                const date = new Date();
                date.setDate(date.getDate() - 1); // Subtract one day from the current date
                
                const year = date.getFullYear();
                const month = ('0' + (date.getMonth() + 1)).slice(-2); // Add leading zero if needed
                const day = ('0' + date.getDate()).slice(-2); // Add leading zero if needed

                let yesterday = `${year}-${month}-${day}`;
                resolve({ 'date':yesterday, 'filter': param });
                //return [year, month, day].join('-');
            } else if (param === 'Last Month') {
                resolve({ 'startDate': moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'), 'endDate': moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'), 'filter': param })
                // resolve('&' + `startDate=${[year, month, day].join('-')}` + '&' + `endDate=${[year, month, 30].join('-')}` +  '&' + `filter=${param}`);
                // resolve({'startDate':[year, month, day].join('-'), 'endDate':[year, month, 30].join('-')});
            }
            else if (param === 'This Month') {
                resolve({ 'startDate': moment().startOf('month').format('YYYY-MM-DD'), 'endDate': moment().endOf('month').format('YYYY-MM-DD'), 'filter': param });
                // resolve('&' + `startDate=${[year, month, day].join('-')}` + '&' + `endDate=${[year, month, 30].join('-')}` +  '&' + `filter=${param}`);

            } else if (param === 'This Week') {
                resolve({ 'startDate': moment().startOf('week').format('YYYY-MM-DD'), 'endDate': moment().endOf('week').format('YYYY-MM-DD'), 'filter': param })
                //  resolve('&' + `startDate=${[year, month, startDate].join('-')}` + '&' + `endDate=${[year, month, day].join('-')}` +  '&' + `filter=${param}`);
            }
            else if (param === 'Custom') {
                const dialogConfig = new MatDialogConfig();
                let dialogRef = this.matDialog.open(CustomDateComponent, {
                    autoFocus: false,
                    height: '350px', width: '450px', data: { "details": "", "action": "Add",selectedDate:this.customeSelectedDate}
                });


                dialogRef.afterClosed().subscribe(value => {
                    console.log("Value=======",value);
                    this.customeSelectedDate=value;
                    resolve({ 'startDate': value.startDate, 'endDate': value.endDate, 'filter': param })
                });
            }
        })
    }

    async exportToPdf(data,fileName) {
        try {
              let pdfData = await this.formatData(data);
               var docDefinition = {
                info: {
                  title: 'Transformer Report',
                },
                pageOrientation: 'landscape',
                pageSize: '4A0',
                content: [
                  {
                    text: '⚡Transformer Performance Report ⚙️',
                    style: 'header',
                    alignment: 'center',
                    margin: [0, 0, 0, 30],
                    color: '#2E86C1'
                  },
                  {
                    stack: [
                      { text: 'Generated On: ' + new Date().toLocaleDateString(), style: 'subheader' },
                      { text: 'Location:'+this.transformerParam, style: 'subheader' }
                    ],
                    alignment: 'left',
                    margin: [0, 0, 0, 20]
                  },
                  {
                    text: 'Below is the detailed transformer report with all recorded parameters.',
                    style: 'intro',
                    margin: [0, 0, 0, 20]
                  },
                  {
                    table: {
                      headerRows: 1,
                      widths: Array(pdfData[0].length).fill('*'), 
                      body:pdfData,
                    },
                    layout: {
                      fillColor: function (rowIndex, node, columnIndex) {
                        return rowIndex === 0 ? '#D6EAF8' : null; 
                      },
                      hLineColor: '#AAB7B8',
                      vLineColor: '#AAB7B8',
                    }
                  }
                ],
                styles: {
                  header: {
                    fontSize: 28,
                    bold: true,
                  },
                  subheader: {
                    fontSize: 16,
                    italics: true,
                  },
                  intro: {
                    fontSize: 14,
                    color: '#34495E'
                  }
                },
                defaultStyle: {
                  fontSize: 10
                }
              };
            pdfMake.createPdf(docDefinition).download(fileName+'.pdf');
        } catch (error) {
          console.log('ERROR:', error);
        }
      // const widths = [ '1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%', '1.5%','1.5%' ];

    }


    formatData(data) {
        return new Promise((resolve,reject) => {
            var dataArr = [];
            var elementCols = Object.keys(data[0]);
            var diffCols = elementCols.filter(x => !this.filterColumns.includes(x))
            dataArr.push(this.filterColumns);
            data.forEach(async element => {
                delete element['Parameter 2'];
                delete element['Parameter 3'];
                delete element['Parameter 4'];
                delete element['Parameter 5'];
                delete element['Parameter 6'];
                delete element['Parameter 7'];
                delete element['Parameter 8'];
                delete element['Parameter 9'];
                delete element['Parameter 10'];
                element = await this.deleteDynamicColumns(element, diffCols);
                let rowValues = [];
                this.filterColumns.forEach(col => {
                    rowValues.push(element[col]);
                });
              console.log('RE ARRANGED COLS:', rowValues );
               // delete element['Energy_Meter_Temprature'];
               //  dataArr.push(Object.values(element));
                dataArr.push(rowValues);
            });
             var finalArr = dataArr.filter(x => !Object.keys(x).includes(diffCols.join(",")));
            resolve(dataArr);
        })
    }

    deleteDynamicColumns(element, cols) {
        return new Promise((resolve,reject) => {
            cols.forEach(col => {
              delete element[col];
            });
            resolve(element);
        })
    }
    async fetchReportData(filter) {
        
        this.ngxLoader.start();
        this.transMngSer.getThresholdValue({transformerid: filter.transformerId}).subscribe((response:any) => {
            if(response.result.length > 0){
                this.thresholdValues = response.result;
            }
        });
        console.log("Filters Data",filter);
        this.windingtemprature = [];
        this.transMngSer.getTransformerDetails({transformerId: filter.transformerId, deletedFlag:'D'}).subscribe(async (response:any) => {
            console.log("asdasd/////",response.details.message)
            this.gradient =  response.details.message.description[0]['kwhreading'];
          this.kvarating = response.details.message.description[0]['kvarating'];
         filter.pageIndex = this.pageIndex;
         filter.pageSize = this.pageSize;
         let filter_Transformer = await this.allDeviceDataForFilter.filter(values=> values.serialnumber == filter.transformerId);
            console.log('Is This DeviceId I want',filter_Transformer[0].deviceId)
            filter.deviceId = filter_Transformer[0].deviceId;
            filter.lastSeenId = this.lastRecordId;
        this.reportService.getReportData(filter).toPromise().then(async (response: any) => {
           // this.transformerIds = await this.getDdlData();
            this.allParameters = this.commonColumns.concat(response.physicalParams, response.electricalParam);
           
            this.physicalParams = this.commonColumns.concat(response.physicalParams);
          
            this.electricalParams = this.commonColumns.concat(response.electricalParam);
            if (this.paramFilter === 'Physical Parameters') {
                this.reportColumns = this.commonColumns.concat(response.physicalParams);
                this.filterColumns = this.commonColumns.concat(response.physicalParams);
            } else if (this.paramFilter === 'Electrical Params') {
                if (response.electricalParam.length > 0) {
                    this.reportColumns = this.commonColumns.concat(response.electricalParam);
                    this.filterColumns = this.commonColumns.concat(response.electricalParam);
                } else {
                    this.reportColumns = [];
                    this.filterColumns = [];
                }
            }
            else if (this.paramFilter === 'All') {
                this.reportColumns = this.commonColumns.concat(response.physicalParams, response.electricalParam);
                this.filterColumns = this.commonColumns.concat(response.physicalParams, response.electricalParam);
            } else {
                if(response && response.physicalParams && response.electricalParam && response.reportData && response.reportData.length > 0) {
                    this.reportColumns = this.commonColumns.concat(response.physicalParams, response.electricalParam);
                    this.filterColumns = this.commonColumns.concat(response.physicalParams, response.electricalParam);

                } else {
                    this.reportColumns = [];
                    this.filterColumns = []
                }
            }
            
            if(response && response.reportData && response.reportData.length > 0) {
                this.lastRecordId = response.reportData[response.reportData.length-1].Recordid;
                this.totalRecords += response.reportData.length + 1;
              this.windingtemprature = [];
              this.historyData = response.reportData;
                this.dataSource = new MatTableDataSource(this.historyData);
                this.deviceID = response.reportData[0]['Deviceid']
                   const columnLength =response.reportData.length;
                   for(let i=0; i<columnLength; i++){
                     if(response.reportData[i]['Oil_Temperature'] !== 0 ){
                        var addition: number = Number(response.reportData[i]['L1'])+Number(response.reportData[i]['L2'])+Number(response.reportData[i]['L3']);
                        var LoadPercentage: number = ((addition/3)/Number(this.kvarating))*100;
                        var windingTemprature: number =  Number(response.reportData[i]['Oil_Temperature'])+((this.gradient*LoadPercentage)/100);
                        this.windingtemprature.push(windingTemprature.toFixed(2));
                        
                     } else {
                        this.windingtemprature.push(0);
                     }
                   }
                   console.log("Addition",this.gradient);
                
                   console.log("Winding Temprature", this.windingtemprature);
                   console.log("DATA FOR REPORTS 123",response.reportData[0]['Humidity']);
                   var element = [];

                   let i = 0;
                   response.reportData.forEach(object => {
                    object.Winding_Temp_By_Cal = this.windingtemprature[i];
                    i++;
                    if(object.Buchholz_Status == 0){
                        object.Buchholz_Status = "Healthy";
                    }
                    if(object.PRV_Status == 0){
                        object.PRV_Status = "Healthy";
                    }
                    if(object.OSR_Status == 0) {
                        object.OSR_Status = "Healthy";
                    }
                     if(object.OTI_Status == 0){
                        object.OTI_Status = "Healthy";
                     }
                     if(object.WTI_Status == 0){
                        object.WTI_Status = "Healthy";
                     }
                     if(object.Buchholz_Status == 1){
                        object.Buchholz_Status = "Oprated";
                    }
                    if(object.PRV_Status == 1){
                        object.PRV_Status = "Oprated";
                    }
                    if(object.OSR_Status == 1) {
                        object.OSR_Status = "Oprated";
                    }
                     if(object.OTI_Status == 1){
                        object.OTI_Status = "Oprated";
                     }
                     if(object.WTI_Status == 1){
                        object.WTI_Status = "Oprated";
                     }
                     if(object.Buchholz_Alarm == 0){
                        object.Buchholz_Alarm = "Healthy"
                     }
                     if(object.Buchholz_Alarm == 1){
                        object.Buchholz_Alarm = "Operated"
                     }
                     if(object.Buchholz_Trip == 0){
                        object.Buchholz_Trip = "Healthy"
                     }
                     if(object.Buchholz_Trip == 1){
                        object.Buchholz_Trip = "Operated"
                     }
                     if(object.OTI_Alarm == 1){
                        object.OTI_Alarm = "Healthy"
                     }
                     if(object.OTI_Alarm == 0){
                        object.OTI_Alarm = "Operated"
                     }
                     if(object.OTI_Trip == 1){
                        object.OTI_Trip = "Healthy"
                     }
                     if(object.OTI_Trip == 0){
                        object.OTI_Trip = "Operated"
                     }
                     if(object.WTI_Alarm == 0){
                        object.WTI_Alarm = "Healthy"
                     }
                     if(object.WTI_Alarm == 1){
                        object.WTI_Alarm = "Operated"
                     }
                     if(object.WTI_Trip == 0){
                        object.WTI_Trip = "Healthy"
                     }
                     if(object.WTI_Trip == 1){
                        object.WTI_Trip = "Operated"
                     }
                  });
                  this.ngxLoader.stop();
                   console.log('REPORT DATA:', response.reportData);
                    this.data = response.reportData;
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;
                    let parameterlength = response.physicalParams.length;
                    for(let i= 0 ; i<= parameterlength ; i++){
                        if(response.physicalParams[i] == 'Tap_Position' ){
                            this.isTapPosition = true;
                            this.reportService.getTapPosition(filter).toPromise().then(async (response: any) => {
                                console.log("What is Tap Position Data",response)
                                this.tapCounter = response.result[0].tapPosition;
                            });
                        } 
                    }
                    //Code for Tap_Position Counter by Rakesh Bhamare
                    /*let datalength = response.reportData.length;
                        let parameterlength = response.physicalParams.length;
                        let tap: string[] = [];
                        for(let i= 0 ; i<= parameterlength ; i++){
                            if(response.physicalParams[i] == 'Tap_Position' ){
                                for (let j = 1; j <= datalength; j++) {
                                    if(response.reportData[j-1]['Tap_Position'] != response.reportData[j]['Tap_Position']){
                                        tap.push(response.reportData[j-1]['Tap_Position']);
                                        this.counter = tap.length+1;
                                    } else {

                                    }
                                }
                            }  else {
                                this.counter = 0;
                            }
                        } //end*/
            } else {
                this.totalRecords = 0;
                this.dataSource = [];
                this.data = [];
                this.deviceID = '';
                this.ngxLoader.stop();
            }
        })
    })

    }
async nextDataLoad(filter){
    filter.pageIndex = this.pageIndex;
    filter.pageSize = this.pageSize;
    console.log("what is Index",this.pageIndex,this.pageSize)
    console.log("What is Page",this.historyData.length/this.pageSize, this.pageIndexNextCompare)
    if(this.historyData.length/this.pageSize == this.pageIndexNextCompare){
    let filter_Transformer = await this.allDeviceDataForFilter.filter(values=> values.serialnumber == filter.transformerId);
       console.log('Is This DeviceId I want',filter_Transformer[0].deviceId)
       filter.deviceId = filter_Transformer[0].deviceId;
       filter.lastSeenId = this.lastRecordId;
   this.reportService.getReportData(filter).toPromise().then(async (response: any) => {
      // this.transformerIds = await this.getDdlData();
       this.allParameters = this.commonColumns.concat(response.physicalParams, response.electricalParam);
      
       this.physicalParams = this.commonColumns.concat(response.physicalParams);
     
       this.electricalParams = this.commonColumns.concat(response.electricalParam);
       if (this.paramFilter === 'Physical Parameters') {
           this.reportColumns = this.commonColumns.concat(response.physicalParams);
           this.filterColumns = this.commonColumns.concat(response.physicalParams);
       } else if (this.paramFilter === 'Electrical Params') {
           if (response.electricalParam.length > 0) {
               this.reportColumns = this.commonColumns.concat(response.electricalParam);
               this.filterColumns = this.commonColumns.concat(response.electricalParam);
           } else {
               this.reportColumns = [];
               this.filterColumns = [];
           }
       }
       else if (this.paramFilter === 'All') {
           this.reportColumns = this.commonColumns.concat(response.physicalParams, response.electricalParam);
           this.filterColumns = this.commonColumns.concat(response.physicalParams, response.electricalParam);
       } else {
           if(response && response.physicalParams && response.electricalParam && response.reportData && response.reportData.length > 0) {
               this.reportColumns = this.commonColumns.concat(response.physicalParams, response.electricalParam);
               this.filterColumns =  this.commonColumns.concat(response.physicalParams, response.electricalParam);            
           } else {
               this.reportColumns = [];
               this.filterColumns = [];
           }
       }
       if(response && response.reportData && response.reportData.length > 0) {
           this.lastRecordId = response.reportData[response.reportData.length-1].Recordid;
         this.windingtemprature = [];
         console.log("sdfsdf",this.pageIndexNextCompare ,this.historyData.length/this.pageSize)
         
            this.historyData.push(...response.reportData);
         
         this.totalRecords = this.historyData.length +1;
         this.dataSource = new MatTableDataSource(this.historyData);
           this.deviceID = response.reportData[0]['Deviceid']
              const columnLength =response.reportData.length;
              for(let i=0; i<columnLength; i++){
                if(response.reportData[i]['Oil_Temperature'] !== 0 ){
                   var addition: number = Number(response.reportData[i]['L1'])+Number(response.reportData[i]['L2'])+Number(response.reportData[i]['L3']);
                   var LoadPercentage: number = ((addition/3)/Number(this.kvarating))*100;
                   var windingTemprature: number =  Number(response.reportData[i]['Oil_Temperature'])+((this.gradient*LoadPercentage)/100);
                   this.windingtemprature.push(windingTemprature.toFixed(2));
                   
                } else {
                   this.windingtemprature.push(0);
                }
              }
            
              var element = [];

              let i = 0;
              response.reportData.forEach(object => {
               object.Winding_Temp_By_Cal = this.windingtemprature[i];
               i++;
               if(object.Buchholz_Status == 0){
                   object.Buchholz_Status = "Healthy";
               }
               if(object.PRV_Status == 0){
                   object.PRV_Status = "Healthy";
               }
               if(object.OSR_Status == 0) {
                   object.OSR_Status = "Healthy";
               }
                if(object.OTI_Status == 0){
                   object.OTI_Status = "Healthy";
                }
                if(object.WTI_Status == 0){
                   object.WTI_Status = "Healthy";
                }
                if(object.Buchholz_Status == 1){
                   object.Buchholz_Status = "Oprated";
               }
               if(object.PRV_Status == 1){
                   object.PRV_Status = "Oprated";
               }
               if(object.OSR_Status == 1) {
                   object.OSR_Status = "Oprated";
               }
                if(object.OTI_Status == 1){
                   object.OTI_Status = "Oprated";
                }
                if(object.WTI_Status == 1){
                   object.WTI_Status = "Oprated";
                }
                if(object.Buchholz_Alarm == 0){
                   object.Buchholz_Alarm = "Healthy"
                }
                if(object.Buchholz_Alarm == 1){
                   object.Buchholz_Alarm = "Operated"
                }
                if(object.Buchholz_Trip == 0){
                   object.Buchholz_Trip = "Healthy"
                }
                if(object.Buchholz_Trip == 1){
                   object.Buchholz_Trip = "Operated"
                }
                if(object.OTI_Alarm == 1){
                   object.OTI_Alarm = "Healthy"
                }
                if(object.OTI_Alarm == 0){
                   object.OTI_Alarm = "Operated"
                }
                if(object.OTI_Trip == 1){
                   object.OTI_Trip = "Healthy"
                }
                if(object.OTI_Trip == 0){
                   object.OTI_Trip = "Operated"
                }
                if(object.WTI_Alarm == 0){
                   object.WTI_Alarm = "Healthy"
                }
                if(object.WTI_Alarm == 1){
                   object.WTI_Alarm = "Operated"
                }
                if(object.WTI_Trip == 0){
                   object.WTI_Trip = "Healthy"
                }
                if(object.WTI_Trip == 1){
                   object.WTI_Trip = "Operated"
                }
             });
           
               this.data = response.reportData;
               this.dataSource.paginator = this.paginator;
               this.dataSource.sort = this.sort;
               //Code for Tap_Position Counter by Rakesh Bhamare
              /* let datalength = response.reportData.length;
                   let parameterlength = response.physicalParams.length;
                   let tap: string[] = [];
                   for(let i= 0 ; i<= parameterlength ; i++){
                       if(response.physicalParams[i] == 'Tap_Position' ){
                           for (let j = 1; j <= datalength; j++) {
                               if(response.reportData[j-1]['Tap_Position'] != response.reportData[j]['Tap_Position']){
                                   tap.push(response.reportData[j-1]['Tap_Position']);
                                   this.counter = tap.length+1;
                               } else {

                               }
                           }
                       }  else {
                           this.counter = 0;
                       }
                   } //end */
       } else {
           this.totalRecords -= 1    
           //this.dataSource = [];
           this.data = [];
           this.deviceID = '';
           this.ngxLoader.stop();
       }
   })
}
}
    generateDataArray(data: any) {
        var reportData: any = [];
        var rowdata: any;
        return new Promise((resolve, reject) => {
            data.forEach(element => {
                rowdata = Object.values(element);
            });
            resolve(rowdata);
        })
    }

    refreshData() {
        this.ngOnInit();
    }
    getRenewalData(){
        this._dashboardService.getRenewalDate(this.currentUserData.userid).subscribe((response: any) => {
          if(response.result.length>0){
            if(response.result[0].RenewalDays >= 365 || response.result[0].dashboardaccess == 0){
              let domObject = document.getElementById("denyDashboardAccess");
              domObject.style.opacity = '0.1';
              let dialogRef = this.matDialog.open(RenewalWindowComponent,{ 
                autoFocus: false,
                          height: '85%', width: '50%', data: {data:response.result},disableClose: true, panelClass: 'custom-dialog-container'
              });
              dialogRef.afterClosed().subscribe((response) => {
              })
            }
          }
        });
        
      }
      getHeaderName(col: string): string {
        switch (col) {
            case 'Transformer Id':
                return 'Transformer Id';
            case 'Deviceid':
                return 'Device Id';
            case 'DATE':
                return 'Date';
            case 'Time':
                return 'Time';
            case 'Oil_Temperature':
                return 'Oil Temperature (°C)';
            case 'Oil_Level':
                return 'Oil Level';
            case 'Winding_Temp_By_Cal':
                return 'Winding Temperature (°C)';
            case 'loadPercentage':
                return 'Load (%)';
            case 'Ambient_Temperature':
                if(this.filter.transformerId == "KR236-1350"){
                    return 'Control pannel - Ambient temp';
                } else {
                    return 'Ambient Temperature (°C)';
                }
            case 'Humidity':
                if(this.filter.transformerId == "KR236-1350"){
                    return 'Control pannel-Humidity';
                } else {
                    return 'Humidity (%)';
                }
            case 'Average_Voltage':
                return 'Average Voltage (V)';
            case 'R_Ph_N':
                return 'R-N Voltage (V)';
            case 'Y_Ph_N':
                return 'Y-N Voltage (V)';
            case 'B_Ph_N':
                return 'B-N Voltage (V)';
            case 'RY_Voltage':
                return 'R-Y Voltage (V)';
            case 'YB_Voltage':
                return 'Y-B Voltage (V)';
            case 'BR_Voltage':
                return 'B-R Voltage (V)';
            case 'L1':
                return 'R - Current (A)';
            case 'L2':
                return 'Y - Current (A)';
            case 'L3':
                return 'B - Current (A)';
            case 'LN':
                return 'N - Current (A)';
            case 'R_Power_Factor':
                return 'R - Power Factor';
            case 'Y_Power_Factor':
                return 'Y - Power Factor';
            case 'B_Power_Factor':
                return 'B - Power Factor';
            case 'Avg_Power_Factor':
                return 'Average Power Factor';
            case 'R_Active_Power':
                return 'R - Active Power (kW)';
            case 'Y_Active_Power':
                return 'Y - Active Power (kW)';
            case 'B_Active_Power':
                return 'B - Active Power (kW)';
            case '3_Phase_Active_Power':
                return '3 Ph Active Power (kW)';
            case 'R_Reactive_Power':
                return 'R - Reactive Power (kvar)';
            case 'Y_Reactive_Power':
                return 'Y - Reactive Power (kvar)';
            case 'B_Reactive_Power':
                return 'B - Reactive Power (kvar)';
            case '3_Phase_Reactive_Power':
                return '3 Ph Reactive Power (kvar)';
            case 'R_apparent_Power':
                return 'R - Apparent Power (kva)';
            case 'Y_apparent_Power':
                return 'Y - Apparent Power (kva)';
            case 'B_apparent_Power':
                return 'B - Apparent Power (kva)';
            case '3_Phase_Apparent_Power':
                return '3 Ph Apparent Power (kva)';
            case 'Frequency':
                return 'Frequency (Hz)';
            case 'VR_THD':
                return 'R - Voltage - THD';
            case 'VY_THD':
                return 'Y - Voltage - THD';
            case 'VB_THD':
                return 'B - Voltage - THD';
            case 'IR_THD':
                return 'R - Current - THD';
            case 'IY_THD':
                return 'Y - Current - THD';
            case 'IB_THD':
                return 'B - Current - THD';
            case 'System_kwh':
                return 'Active(kWh)';
            case 'logSystem_Kwh':
                return 'Active Forwarded (kWh)';
            case 'System_Kvah':
                return 'Apparent Forwarded (kvah)';
            case 'lt1':
                return 'INCOMER CABLE R PHASE';
            case 'lt2':
                return 'INCOMER CABLE Y PHASE'
            case 'lt3':
                return 'INCOMER CABLE B PHASE'
            case 'lt4':
                return 'OUTGOING BUS BAR R PHASE'
            case 'lt5':
                return 'OUTGOING BUS BAR Y PHASE'
            case 'lt6':
                return 'OUTGOING BUS BAR B PHASE'
            case 'lt7':
                return 'OUTGOING BUS BAR RIGHT  R PHASE'
            case 'lt8':
                return 'OUTGOING BUS BAR RIGHT  Y PHASE'
            case 'lt9':
                return 'OUTGOING BUS BAR RIGHT  B PHASE'
            case 'lt10':
                return 'OUTGOING BUS BAR LEFT R PHASE'
            case 'lt11':
                return 'OUTGOING BUS BAR LEFT Y PHASE'
            case 'lt12':
                return 'OUTGOING BUS BAR LEFT B PHASE'
            case 'Ambient_Temperature_LT':
             if(this.filter.transformerId == "KR236-1350"){
                return 'Breaker compartment-Ambient temp'
             } else {
               return  'Ambient_Temperature_LT'
             }
                
            case 'Humidity_LT':
                if(this.filter.transformerId == "KR236-1350"){
                    return 'Breaker compartment-Humidity'
                 } else {
                   return  'Humidity_LT'
                 }
            case 'Ambient_Temperature_HT':
                if(this.filter.transformerId == "KR236-1350"){
                    return 'Cable Compartment-Ambient temp'
                 } else {
                   return  'Ambient_Temperature_HT'
                 }
            case 'Humidity_HT':
                if(this.filter.transformerId == "KR236-1350"){
                    return 'Cable Compartment-Humidity'
                 } else {
                   return  'Humidity_HT'
                 }
            case 'PRV_Status':
                if(this.filter.transformerId == "KR181-1295" || this.filter.transformerId == "KR182-1296"){
                    return 'Master Trip';
                } else {
                    return 'PRV_Status';
                }
            case 'OTI_Status':
                if(this.filter.transformerId == "KR181-1295" || this.filter.transformerId == "KR182-1296"){
                    return 'MOG OLTC';
                } else {
                    return 'OTI_Status';
                }
            default:
                return col;
        }
    }
    DailyConsumptionReport(){
        this.ngxLoader.start();
        this.reportService.getDailyConsumptionReport(this.deviceID).toPromise().then(async (response: any) => {
            if(response.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
                let downloadURL = window.URL.createObjectURL(response);
                saveAs(downloadURL,'Yesterdays_Consumption_Report'); 
                this.ngxLoader.stop();       
            } else {
                this.toastr.warning("No data was found for yesterday.");
                this.ngxLoader.stop();       
            }
        });
    }
    onFolderSelect(event: any): void {
        const files: File[] = Array.from(event.target.files);
        if (files.length > 0) {
          this.uploadFolder(files); 
        }
      }
        uploadFolder(files: File[]): void {
            this.isUploading = true;
          this.reportService.uploadFolder(files).subscribe(
            (response) => {
                this.isUploading = false;
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Your operation completed successfully!',
                    confirmButtonText: 'OK'
                  });
              console.log('Folder uploaded successfully:', response);
            },
            (error) => {
              console.error('Error uploading folder:', error);
            }
          );
        }
    getUploadData(){
        this.isDownloading = true;
        this.reportService.getUploadData().subscribe(
            (response:any) => {
                if(response.code == 1){
                    this.isDownloading = false;
                    Swal.fire({
                        title: 'Success!',
                        text: 'Data updated successfully.',
                        icon: 'success',
                        timer: 1000, 
                        showConfirmButton: false 
                      });
                } else {
                    this.isDownloading = false;
                }
            });
    }
    onPageChange(event: PageEvent) {
        console.log("asdsa",event.pageIndex,this.pageIndex)
        if (event.pageIndex > this.pageIndex) {
            this.pageIndexNextCompare++;
        this.nextDataLoad(this.filter);
      } else {
        this.pageIndexNextCompare--;
      }
      this.pageIndex = event.pageIndex;
    }

    async downloadExcel(type:any) {
        console.log("asdasd",this.reportColumns)
        this.isDownloading = true;
        let isIncrement = 0;
        let excelData: any= [];
        this.filter.pageSize = 50;
        
        const filter_Transformer = this.allDeviceDataForFilter.filter(values => values.serialnumber == this.filter.transformerId);
        if(filter_Transformer[0].heartBeat <=5){
            this.filter.pageSize = 300; 
        }
        this.filter.deviceId = filter_Transformer[0].deviceId;
        let days = 0;
        let fileName;
        if(this.filter.filter == 'Today' || this.filter.filter == 'Yesterday'){
            days = 1440;
            fileName =this.filter.date;
        } else if(this.filter.filter == 'This Week'){
            days = 10080;
            fileName = this.filter.startDate+'_to_'+this.filter.endDate;
        } else if (this.filter.filter == 'This Month' || this.filter.filter == 'Last Month' ){
            days = 43200;
            fileName = this.filter.startDate+'_to_'+this.filter.endDate;
        } else if(this.filter.filter == "Custom"){
            const start:any = new Date(this.filter.startDate);
            const end:any = new Date(this.filter.endDate);
            const diffInDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24));
            days = 1440*Number(diffInDays)
        }
      
        this.remainingTime =  Number(days /Number(filter_Transformer[0].heartBeat))/ this.filter.pageSize;
        for (let i = 0; i <= isIncrement; i++) {
          this.filter.pageIndex = i;    
          if(filter_Transformer[0].heartBeat <=5){
            this.filter.pageSize = 300; 
            } else {
                this.filter.pageSize = 50;
            }
          try {
            const response: any = await this.reportService.getReportData(this.filter).toPromise();
            if (response.result !='failed' && response.reportData && response.reportData.length > 0) {
                console.log("data",response)
              isIncrement++; // More data to fetch
                
              const windingTemprature = [];
              this.deviceID = response.reportData[0]['Deviceid'];
      
              const columnLength = response.reportData.length;
              for (let i = 0; i < columnLength; i++) {
                if (response.reportData[i]['Oil_Temperature'] !== 0) {
                  const addition = Number(response.reportData[i]['L1']) + Number(response.reportData[i]['L2']) + Number(response.reportData[i]['L3']);
                  const LoadPercentage = ((addition / 3) / Number(this.kvarating)) * 100;
                  const windingTemp = Number(response.reportData[i]['Oil_Temperature']) + ((this.gradient * LoadPercentage) / 100);
                  windingTemprature.push(windingTemp.toFixed(2));
                } else {
                  windingTemprature.push(0);
                }
              }
      
              let w = 0;
              response.reportData.forEach(object => {
                object.Winding_Temp_By_Cal = windingTemprature[w++];
                object.Buchholz_Status = object.Buchholz_Status === 0 ? "Healthy" : "Oprated";
                object.PRV_Status = object.PRV_Status === 0 ? "Healthy" : "Oprated";
                object.OSR_Status = object.OSR_Status === 0 ? "Healthy" : "Oprated";
                object.OTI_Status = object.OTI_Status === 0 ? "Healthy" : "Oprated";
                object.WTI_Status = object.WTI_Status === 0 ? "Healthy" : "Oprated";
      
                object.Buchholz_Alarm = object.Buchholz_Alarm === 0 ? "Healthy" : "Operated";
                object.Buchholz_Trip = object.Buchholz_Trip === 0 ? "Healthy" : "Operated";
                object.OTI_Alarm = object.OTI_Alarm === 1 ? "Healthy" : "Operated";
                object.OTI_Trip = object.OTI_Trip === 1 ? "Healthy" : "Operated";
                object.WTI_Alarm = object.WTI_Alarm === 0 ? "Healthy" : "Operated";
                object.WTI_Trip = object.WTI_Trip === 0 ? "Healthy" : "Operated";
              });
      
              excelData.push(...response.reportData);
            } else {
              this.data = [];
              this.deviceID = '';
              this.isPageDownload = false;
            }
      
          } catch (err) {
            console.error(`Error fetching page ${i + 1}:`, err);
          }
          this.remainingTime = Number(this.remainingTime-1).toFixed(2);
          await this.wait(1000); // Wait 1 sec between calls
        }
      
        this.isDownloading = false;
        console.log('Download completed. Exporting Excel...',this.idFilter);
        if(type == 'excel'){
            this.exportToExcel(excelData, this.idFilter+'_Transformer_Report_'+fileName);
        } else if(type == 'pdf'){
            this.exportToPdf(excelData, this.idFilter+'_Transformer_Report_'+fileName);
        }
      }
      

// Sleep helper function
wait(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  
  exportToExcel(data: any[], fileName: string): void {
    this.downloadMessage = "Exporting Data to Excel";
  
    const MAX_ROWS = 1048576;
    const MAX_COLS = 16384;
  
    const header = this.reportColumns;
  
    // SAFEGUARD: Filter out invalid rows
    const cleanedRows = data
      .filter(row => typeof row === 'object' && row !== null)
      .map(row =>
        header.map(col => {
          const val = row[col];
          return val === undefined || val === null ? '' : val;
        })
      );
  
    const sheetData = [header, ...cleanedRows];
  
    // Extra logging to catch structural issues
    if (!Array.isArray(sheetData) || !Array.isArray(sheetData[0])) {
      console.error("🚫 sheetData structure is invalid", sheetData);
      alert("Export failed: Invalid sheet data structure.");
      return;
    }
  
    if (sheetData.length > MAX_ROWS || header.length > MAX_COLS) {
      console.error("❌ Excel limits exceeded");
      alert(`Data too large. Max allowed: ${MAX_ROWS} rows, ${MAX_COLS} columns.`);
      return;
    }
  
    try {
      const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(sheetData);
  
      worksheet['!cols'] = header.map(col => ({
        wch: (col && col.length) ? (col.length + 5) : 10
      }));
  
      const range = XLSX.utils.decode_range(worksheet['!ref']!);
      for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          const cell = worksheet[cellRef];
          if (cell) {
            cell.s = {
              alignment: { horizontal: 'center', vertical: 'center' },
              border: {
                top: { style: 'thin', color: { rgb: '000000' } },
                bottom: { style: 'thin', color: { rgb: '000000' } },
                left: { style: 'thin', color: { rgb: '000000' } },
                right: { style: 'thin', color: { rgb: '000000' } }
              },
              font: R === 0 ? { bold: true } : {}
            };
          }
        }
      }
  
      const workbook: XLSX.WorkBook = {
        SheetNames: ['Sheet1'],
        Sheets: {
          Sheet1: worksheet
        }
      };
  
      const excelBuffer: any = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });
  
      const blob: Blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      });
  
      FileSaver.saveAs(blob, `${fileName}.xlsx`);
    } catch (err) {
      console.error("❌ Excel write error:", err);
      alert("❌ Failed to export Excel. Please check console for details.");
    }
  }
  
  
}  
